import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
export {};
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
